var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kit-block kit-tours" }, [
    _c("div", { staticClass: "tours-header" }, [
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.block.title) } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tours-nav" },
        _vm._l(_vm.block.tours, function(item, index) {
          return _c(
            "a",
            {
              key: "nav-" + index,
              staticClass: "nav-bullet",
              class: { active: _vm.ui.currentSlide == index },
              on: {
                click: function($event) {
                  return _vm.$refs.tourSlider.goToSlide(index)
                }
              }
            },
            [_c("span")]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "kit-tours-slider" },
      [
        _c(
          "vueper-slides",
          {
            ref: "tourSlider",
            attrs: {
              touchable: false,
              autoplay: false,
              bullets: false,
              arrows: false,
              "fixed-height": "350px"
            },
            on: { slide: _vm.slideChanged }
          },
          _vm._l(_vm.block.tours, function(tour, i) {
            return _c("vueper-slide", {
              key: i,
              attrs: {
                link: "/tours/" + tour.tour.post_name,
                image: tour.image.sizes.large
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "tour-slide-overlay" }, [
                          _c("div", { staticClass: "tour-slide-content" }, [
                            _c("h3", {
                              domProps: {
                                innerHTML: _vm._s(tour.tour.post_title)
                              }
                            }),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                _vm._s(tour.tour.days.length) +
                                  " " +
                                  _vm._s(
                                    tour.tour.days.length > 1 ? "Days" : "Day"
                                  ) +
                                  " // " +
                                  _vm._s(_vm.getStops(tour.tour.days)) +
                                  " Stops"
                              )
                            ])
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-prev arrow-nav",
            on: {
              click: function($event) {
                return _vm.$refs.tourSlider.previous()
              }
            }
          },
          [
            _c("svg", { staticClass: "circle-border" }, [
              _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-angle-left" })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-next arrow-nav",
            on: {
              click: function($event) {
                return _vm.$refs.tourSlider.next()
              }
            }
          },
          [
            _c("svg", { staticClass: "circle-border" }, [
              _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-angle-right" })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/KitBlocks/KitTours.vue?vue&type=template&id=7ee192d6&
// module id = 526
// module chunks = 0